import { createContext, useContext } from 'react';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';

const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY as string | undefined;

type ExecuteRecaptcha = ((action: string) => Promise<string>) | undefined;
const RecaptchaContext = createContext<ExecuteRecaptcha>(undefined);

function InnerProvider({ children }: { children: React.ReactNode }) {
    const { executeRecaptcha } = useGoogleReCaptcha();
    return <RecaptchaContext.Provider value={executeRecaptcha}>{children}</RecaptchaContext.Provider>;
}

export function RecaptchaProvider({ children }: { children: React.ReactNode }) {
    if (!recaptchaSiteKey) return <>{children}</>;
    return (
        <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
            <InnerProvider>{children}</InnerProvider>
        </GoogleReCaptchaProvider>
    );
}

export function useRecaptchaToken() {
    return useContext(RecaptchaContext);
}
